import { getVoucherCode, getPageName, getOnecomConfig } from "store/selectors";
import { getNormalizedCartItems } from "../../utils";

const checkoutStep = (stepNumber) => (dispatch, getState) => {
  const state = getState();
  const coupon = getVoucherCode(state);
  const items = getNormalizedCartItems(state);
  const stepName = getPageName(state);
  const { currency } = getOnecomConfig(state) || {};

  window.GTM.pushCheckoutStep({
    coupon,
    items,
    stepNumber,
    stepName,
    currency,
  });
};

export default checkoutStep;
